import styled from 'styled-components';
import {device} from '../../../styled/device';
import {Button} from '../../Button';

export const Content = styled.div`
  display: grid;
  grid-template-columns: minmax(370px, 855px) minmax(300px, 328px);
  column-gap: 43px;
  row-gap: 25px;
  padding-bottom: 100px;

  @media (max-width: ${device.tablet}) {
    grid-template-columns: 1fr;
    justify-items: center;
  }
`;

export const ListGuestTaxes = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(330px, 1fr));
  max-width: 855px;
  gap: 39px 25px;

  @media (max-width: ${device.tablet}) {
    grid-template-columns: minmax(330px, 1fr);
  }
`;

export const CardTitle = styled.div`
  font-family: Poppins-SemiBold, sans-serif;
  font-size: 18px;
`;

export const TotalColumn = styled.div`
  position: relative;
`;

export const TotalPriceTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #e5e5eb;
  border-radius: 24px 24px 0 0;
  padding: 20px 37px;

  span:nth-child(1) {
    font-family: Poppins-SemiBold, sans-serif;
    font-size: 19px;
  }
  span:nth-child(2) {
    font-family: Poppins-Bold, sans-serif;
    font-size: 32px;
  }
`;

export const TotalPriceBlock = styled.div`
  position: fixed;
  width: 328px;
  height: 209px;
  border: 1px solid #e6e8ec;
  border-radius: 24px;

  @media (max-width: ${device.tablet}) {
    position: relative;
    height: auto;

    & ${TotalPriceTitle} {
      border-radius: 24px;
    }
  }
`;

export const NextButton = styled(Button)`
  margin: 50px auto 0;
  width: 250px;
  max-width: 300px;

  @media (max-width: ${device.tablet}) {
    margin: 0;
    width: auto;
  }
`;

export const CardWrapper = styled.div`
  min-width: 320px;
  max-width: 415px;
  border: 1px solid #e6e8ec;
  border-radius: 24px;
  padding: 26px 32px;

  & .touristTaxesCard {
    justify-content: space-between;
  }

  @media (max-width: ${device.mobileS}) {
    max-width: 310px;
    min-width: auto;
    padding: 18px;
  }
`;

export const SubmitButtonWrapper = styled.div`
  margin: 30px 0;

  & .progress {
    display: none;
  }

  @media (max-width: ${device.tablet}) {
    & .progress {
      display: inline;
      font-family: Poppins-Medium, sans-serif;
      font-size: 21px;
      color: #777e90;
    }

    position: fixed;
    margin: 0;
    display: flex;
    justify-content: space-between;
    padding: 16px;
    width: 100%;
    align-items: center;
    background-color: #f7fafc;
    border-top: 1px solid #b1b5c4;
    bottom: 0;
    left: 0;
    z-index: 5;
  }
`;
